<template>
<v-container class="pa-2">
<v-card class="pa-4">
<v-card-title>
<h1 class="mr-2 subheading grey--text">Σύνδεση</h1>
</v-card-title>
<v-card-text>
        <v-row justify="center">
          <v-text-field label="API endpoint" type="url" class="mx-6 justify-center"  v-model="apiurl"/>
          <v-btn @click="persist">Save</v-btn>
        </v-row>
        </v-card-text>
        <v-card-text>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="pa-2"
  >
    <v-text-field
      v-model="username"
      :counter="15"
      :rules="nameRules"
      label="User Name"
      required
    ></v-text-field>

  <v-text-field
      v-model="password"
      label="Password"
      required
      type="password"
    ></v-text-field>
    <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'You must agree to continue!']"
      label="Do you agree?"
      required
    ></v-checkbox>

    <v-btn
      color="success"
      class="mr-4"
      @click="handleSubmit"
    >
      Login
    </v-btn>
  </v-form>
  </v-card-text>
  </v-card>
  </v-container>
</template>

<script>
export default {
    data () {
        return {
            apiurl: process.env.VUE_APP_API_ENDPOINT,
            username: '',
            password: '',
            submitted: false,
            nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      checkbox: false,
      valid: true,
        }
    },
    computed: {
        loggingIn () {
            return this.$store.state.authentication.status.loggingIn;
        }
    },
    created () {
        // reset login status
        this.$store.dispatch('authentication/logout');
    },
    mounted() {
      if (localStorage.apiurl) {
        this.apiurl = localStorage.apiurl;
      }
      this.$api.defaults.baseURL = this.apiurl;
    },
    methods: {
      persist() {
        localStorage.apiurl = this.apiurl;
        this.$api.defaults.baseURL = this.apiurl;
    },
    validate () {
        this.$refs.form.validate().then(this.handleSubmit());
      },
        // eslint-disable-next-line
     handleSubmit () {
            this.submitted = true;
            const { username, password } = this;
            const { dispatch } = this.$store;
            if (username && password) {
                let redirect = '/';
                if (this.$route.query.redirect != null) {
                  redirect = this.$route.query.redirect;
                }
                console.log(this.$route.query.redirect, redirect)
                dispatch('authentication/login', { username, password, redirect});
            }
            
        }
    }
};
</script>
